import API from "../../api";
import {
  API_COMMENT_FILE_DETAIL
} from "../../constants/api";

const getCommentFileDetail = async (dataId) => {
  try {
    const response = await API.get(API_COMMENT_FILE_DETAIL(dataId));
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const CommentFile = {
  getCommentFileDetail
};

export {
  CommentFile as default,
  getCommentFileDetail
}